import React from 'react';
import { Card } from 'react-bootstrap';
import styles from './RecentProfileCard.module.css';
import { NavLink } from 'react-router-dom';
import defaultImage from '../../assets/images/default-profile-cover.png';

const classNames = require('classnames');

function RecentProfileCard({ cardTitle, cardSubtitle, cardText, cardImg, guid }) {
  return (
    <NavLink to={`/admin/profile/edit/${guid}`}>
      <Card className={classNames(styles.recentProfileCard, 'border-0 rounded-8 mb-4')}>
        <Card.Img className={classNames(styles.recentProfileCardImg, 'rounded-bottom-0 rounded-8')} src={cardImg || defaultImage} />
        <Card.Body>
          <Card.Title className={classNames(styles.is360View, 'cardTitle')}>{cardTitle}</Card.Title>
          <Card.Subtitle className={styles.cardSubtitle}>{cardSubtitle}</Card.Subtitle>
          <Card.Text className={styles.cardText}>{cardText}</Card.Text>
        </Card.Body>
      </Card>
    </NavLink>
  )
}

export default RecentProfileCard;
